import triggerTracking from '@blueprint/tracking';
import { SharingCategory } from './ListingSharing';

const TRACKING_EVENT = 'GAEvent';
const TRACKING_CATEGORY_LISTING_DETAILS = 'listing details';

export const trackFacebookShare = (
    listingId: number,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'facebook'
    });
};

export const trackTwitterShare = (
    listingId: number,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'twitter'
    });
};

export const trackClipboardShare = (
    listingId: number,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'copy link'
    });
};

export const trackWhatsAppShare = (
    listingId: number,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'whatsapp'
    });
};
